<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  watch: {},
  methods: {},
  computed: {},
  mounted() {},
}
</script>

<style lang="less" scoped></style>
